(function(){
  var GRAD='linear-gradient(135deg,#F7941D 0%,#D7261E 100%)';
  var CART='<svg class="bk-buy-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h15l-1.6 8.2a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.6L5.2 4H3"/><circle cx="9.5" cy="20.5" r="1.2"/><circle cx="17.5" cy="20.5" r="1.2"/></svg>';
  function num(t){var m=(t||'').replace(/[^\d.,]/g,'').replace(/,(?=\d{3}\b)/g,'').replace(/\.(?=\d{3}\b)/g,'');m=m.replace(',','.');var n=parseFloat(m);return isNaN(n)?null:n}
  function fmt(n){return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
  function buy(b){
    if(b.getAttribute('style'))b.removeAttribute('style');
    b.querySelectorAll('[style]').forEach(function(x){x.removeAttribute('style')});
    if(!b.classList.contains('bk-buy'))b.classList.add('bk-buy');
    if(!b.querySelector('.bk-buy-ico')){
      var t=b.querySelector('.es-button-title');var txt=t?t.textContent.trim():'Kupi odmah';
      if(/^kupi odmah$/i.test(txt))txt='Kupi odmah';
      b.innerHTML=CART+'<span class="es-button-title">'+txt+'</span>';
    }
  }
  function cta(b){
    if(!b.classList.contains('bk-buy-cta'))b.classList.add('bk-buy-cta');
    if(b.dataset.bkg&&b.dataset.bkg===b.style.background)return;
    b.style.setProperty('background',GRAD,'important');b.style.setProperty('box-shadow','0 8px 18px -8px rgba(215,38,30,.75)','important');b.dataset.bkg=b.style.background;
  }
  function price(el){
    if(el.querySelector('.bk-cur'))return;var t=el.textContent.replace(/\s+/g,' ').trim();var m=t.match(/^(Od|od)?\s*([\d.,]+)\s*(RSD|din\.?)$/);if(!m)return;
    var n=num(m[2]);if(n===null)return;
    el.innerHTML=(m[1]?'<span class="bk-od">od</span>':'')+fmt(n)+'<span class="bk-cur">RSD</span>';
  }
  function run(){
    document.querySelectorAll('.es-popup-button').forEach(buy);
    document.querySelectorAll('.es-cta-btn').forEach(cta);
    document.querySelectorAll('.price .price-item').forEach(price);
  }
  var q=false;function sched(){if(q)return;q=true;requestAnimationFrame(function(){q=false;run()})}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  window.addEventListener('load',run);
  new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var m=ms[i],t=m.target;
    if(m.type==='attributes'){if(t.classList&&(t.classList.contains('es-popup-button')||t.classList.contains('es-cta-btn'))){sched();return}continue}
    if(m.type==='childList'){for(var j=0;j<m.addedNodes.length;j++){var n=m.addedNodes[j];if(n.nodeType===1&&(n.matches('.es-popup-button,.es-cta-btn,.price,.price-item')||n.querySelector('.es-popup-button,.es-cta-btn,.price-item'))){sched();return}}}
    var e=t&&(t.nodeType===1?t:t.parentElement);if(e&&e.closest&&e.closest('.price-item')&&!e.closest('.price-item').querySelector('.bk-cur')){sched();return}
  }}).observe(document.documentElement,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style']});
})();
